import axios from '../assets/axios'
import { getKey } from '../assets/utils'
const MAX_AGE = 60 * 1000
export default {
  state: {
    hasJsBridge: false,
    statusBarHeight: 0,
    caseList: [],
    caseListV2: {
      bannerShowList: []
    },
    bannerList: [],
    cache: {}, // 缓存控制
    dictionary: {} // 数据字典
  },

  mutations: {
    // 设置数据字典值
    setDictionary (state, dictionary) {
      state.dictionary = dictionary
    },

    // 设置推荐位
    setCaseList (state, data) {
      state.caseList = data
    }, 

    // 设置推荐位
    setCaseList2 (state, data) {
      state.caseListV2 = data
    }, 
    // 设置广告列表
    setBannerList (state, data) {
      state.bannerList = data
    }
  },

  actions: {
    // 获取字典值
    fetchDictionaryX: ({ commit, state }, key = '') => {
      const now = new Date().getTime()
      if (now - (state.cache['dictionary'] || 0) < MAX_AGE && JSON.stringify(state.dictionary) !== '{}') {
        return key ? state.dictionary[key] : state.dictionary
      } else {
        state.cache['dictionary'] = new Date().getTime()
        return axios.post('/order/v1/dict').then(response => {
          if (response.data.success) {
            commit('setDictionary', response.data.data)
            return key ? response.data[key] : response.data.data
          }
          return response.data.data
        }).catch(err => {
          return err
        })
      }
    },

    // 首页推荐位列表
    // 已经包含了所有的活动列表 
    async getCaseListX ({ commit }, params) {
      const response = await axios.get('/index/v1/showcases', { params })
      if (response.data.success) {
        commit('setCaseList', response.data.data)
      }
      return response.data
    },
    // 新推荐位接口 用于获取活动的banner
    async getCaseList2X ({ commit }, params) {
      const response = await axios.post('/index/v2/showcase', params)
      if (response.data.success) {
        commit('setCaseList2', response.data.data)
      }
      return response.data
    },
    // 添加埋点接口
    async dataPoint ({ commit }, params) {
      let value = {
        bussLine: 'TMD',
        args: {
          create_time: new Date().getTime(),
          channel: getKey('channel') || 'official',
          user_id: getKey('userInfo', 'userId'),
          terminal: getKey('terminal') || 'H5',
          phone: getKey('userInfo', 'mobile'),
          gid: localStorage.getItem('gid'),
          ...params
        }
      }
      const response = await axios.post('/index/v1/data-point', value)
      return response.data
    },
    async checkChannelExist ({ commit }, params) {
      const response = await axios.post('/channel/v1/checkChannelExist', params)
      return response.data
    },
    async uploadSignUrl ({ commit }, params) {
      const response = await axios.post('/oss/v1/upload/sign-url', params)
      return response.data
    },
    async rosewalletConfig () {
      const response = await axios.post('/channel/process/v1/rosewallet/config')
      return response.data
    }

  }
}
